<template>
   <div id="cover-spin" v-if="loading"></div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import _ from 'lodash';
import Tabs from 'vue-tabs-with-active-line';
import liffService from "@/services/liff";
// @ is an alias to /src
export default {
  name: "Quiz",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      quizId:0,
      answer:0,
    };
  },
  methods: {
    async loadUserData() {
    const queryString = decodeURIComponent(window.location.search);
      const params = new URLSearchParams(queryString);
      if(params.get("quizId"))
          this.quizId = params.get("quizId");
      if(params.get("answer"))
          this.answer = params.get("answer");
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      this.displayName = profile.displayName ? profile.displayName : "none";
      this.statusMessage = profile.statusMessage
        ? profile.statusMessage
        : "none";
      if (this.userId) {
        const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
        if (user) {
            await firebase.firestore().collection('quiz').where('userId','==',this.userId).where('quizId','==',this.quizId).get().then(async (snapshot) => {
                if(snapshot.size > 0) {
                    await window.liff.sendMessages([
                        {
                            "type": "text",
                            "text": "ลูกค้าตอบคำถามแล้วนะคะ รอร่วมกิจกรรมกับน้องออโต้ใหม่นะคะ จะมาเร็วๆนี้ค่ะ 😘😘",
                        }
                    ]);
                    window.liff.closeWindow();
                }else{
                    firebase.firestore().collection('quiz').doc(this.userId+'-'+this.quizId).set({
                        userId:this.userId,
                        quizId:this.quizId,
                        answer:this.answer,
                        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                    }).then(async()=>{
                        if(this.quizId == 1 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT น้องออโต้เสียใจด้วยนะคะทางเราตอนนี้มีแค่แลกเป็นเครดิตเท่านั้นค่ะ สนใจสอบถามแอดมินได้ 24 ชั่วโมงนะคะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 2 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 2){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT น้องออโต้เสียใจลืมน้องออโต้คนนี้ซะแล้ว ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }
                    });
                }
            });
        }else{
          router.replace("/register");
        }
      }
      this.isDisabled = false;
    },
  }
};
</script>
<style scoped>
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
.canredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #EE4D2D; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
.cantredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #a5a4a4; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
button.tabs__item .tabs__item_active .default-tabs__item_active .default-tabs__item {
  justify-content: center !important;
  flex: 1 !important;
  display: flex !important;
}
</style>
<style lang="scss">
.default-tabs {
  position: relative;
  margin: 0 auto;
  display: flex;
  &__item {
    justify-content: center;
    flex: 1;
    display: flex;
    //display: inline-block;
    margin: 0 5px;
    padding: 10px;
    padding-bottom: 8px;
    padding-top: 0px;
    font-size: 16px;
    letter-spacing: 0.8px;
    color: #fff;
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;
    &_active {
      color: #E95454;
    }
    &:hover {
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:focus {
      outline: none;
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #E95454;
    transition: transform 0.4s ease, width 0.4s ease;
  }
}
</style>